<template>
    <div style="background-color: #fafafa;">
		<div class="rankConfirmCont">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top: 0;">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="">
					<div v-for="(item, index) in list" class="card" :key="item.uuid">
						<table class="layout">
							<tr style="width: 100%;" >
								<td style="width: 40%;">
									<van-image
											width="150"
											height="100"
											:src="item.imageUrl"
									/>
									<p>
										<span style="font-weight: bold">附加金额:</span><span style="font-weight: bold;color: #1890ff;">¥{{item.extraAmount}}</span><br/>
										<span style="font-weight: bold">片数:</span><span style="font-weight: bold;color: #1890ff;">{{item.pieces}}</span><br/>
										<span style="font-weight: bold">组数:</span><span style="font-weight: bold;color: #1890ff;">{{item.quantity}}</span><br/>
										<span style="font-weight: bold">每组:</span><span style="font-weight: bold;color: #1890ff;">¥{{item.unitedPrice}}</span><br/>
										<span style="font-weight: bold">金额小计:</span><span style="font-weight: bold;color: #1890ff;">¥{{item.subtotal}}</span>
									</p>
								</td>
								<td style="padding-left: 5px;">
									<p>
										<span style="font-weight: bold">型号:</span><span>{{item.radIdname}}</span><br/>
										<span style="font-weight: bold">中心距:</span><span>{{item.centerSpacing}}</span><br/>
										<span style="font-weight: bold">颜色:</span><span>{{item.colorname}}</span><br/>
										<span style="font-weight: bold">接口口径:</span><span>{{item.calibername}}</span><br/>
										<span style="font-weight: bold">进水方式:</span><span>{{item.waterFlowname}}</span>
									</p>
									<p>
										<span style="font-weight: bold">特殊规格:</span><span>{{item.custom_text_1}}</span><br/>
										<span style="font-weight: bold">特殊进水方式:</span><span>{{item.isSpecials}}</span><br/>
										<span style="font-weight: bold">备注:</span><span>{{item.mainRemark}}</span><br/>
										<span style="font-weight: bold">代码:</span><span>{{item.model}}</span><br/>
										<span style="font-weight: bold">折后金额:</span><span style="font-weight: bold;color: #1890ff;">¥{{item.discountAmount}}</span>
									</p>
								</td>
							</tr>
						</table>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Field, Panel, Button, List, Image, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import {API_URL} from "../../common/config";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				uuid: "",
				serialNumber: "",
				tableName: "",
				imageUrl: API_URL + "/oa/common/attachment/showImage?id="
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
            [Field.name]: Field,
			[NavBar.name]: NavBar,
			[Image.name]: Image,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: async function () {
			this.uuid = this.$route.query.uuid || "";
			this.serialNumber = this.$route.query.serialNumber || "";
			this.tableName = this.$route.query.tableName || "";
		},
        methods: {
			async onLoad() {
				this.pageIndex++;
				let resp = await dealerOrderService.getRadOrderDetailList(this.pageIndex, this.uuid, this.tableName);
				resp.data.Data.data.forEach(item => {
					if (item.isSpecials && item.isSpecials.length > 15) {
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 15);
						item.isSpecials += "...";
					}
					if (item.mainRemark && item.mainRemark.length > 15) {
						let temp = item.mainRemark;
						item.mainRemark = temp.substring(0, 15);
						item.mainRemark += "...";
					}
					if(this.tableName === "vsheet_rad_delivery"){
						item.quantity = item.actualOut;
					}
				});
				resp.data.Data.data.forEach(item => {
					item.imageUrl = this.imageUrl + item.imageIds.split(",")[0];
				});
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				this.loading = false;
				this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			}
		}
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}

	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.rankConfirmCont{
		width:100%;
		margin:0 auto;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>